export default __webpack_public_path__ + "static/Frame 178-85f75a5c75b4390645dde61b514f79de.svg";